import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a144542c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "score" }
const _hoisted_3 = { class: "num" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "itemBox" }
const _hoisted_6 = { class: "scorenum" }
const _hoisted_7 = { class: "scoreright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        title: $setup.t('me.jfmx'),
        "left-arrow": "",
        fixed: "",
        "z-index": "99",
        placeholder: "",
        onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back()))
      }, null, 8 /* PROPS */, ["title"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString($setup.score), 1 /* TEXT */),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('me.jf')), 1 /* TEXT */)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, "+" + _toDisplayString(item.amount) + _toDisplayString(_ctx.$t('me.jf')), 1 /* TEXT */),
          _createCommentVNode(" <div>{{item.type_val}}</div> "),
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.time), 1 /* TEXT */)
        ])
      ]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 64 /* STABLE_FRAGMENT */))
}